import { render, staticRenderFns } from "./MenuOpen.vue?vue&type=template&id=179c83d7"
import script from "./MenuOpen.vue?vue&type=script&lang=js"
export * from "./MenuOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports